





















import {Vue} from "vue-property-decorator";

export default class Contact extends Vue {

}
